'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { MoreVertical, Upload, Download } from 'lucide-react';
export function ExcelActionsMenu({ onImport, onExport, canImport = true, canExport = true, }) {
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        const handleEscape = (event) => {
            if (event.key === 'Escape')
                setIsOpen(false);
        };
        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
            document.addEventListener('keydown', handleEscape);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleEscape);
        };
    }, [isOpen]);
    // Nothing to offer → don't render the trigger at all
    if (!canImport && !canExport)
        return null;
    return (_jsxs("div", { className: "relative", ref: menuRef, children: [_jsx("button", { type: "button", onClick: () => setIsOpen(!isOpen), className: "inline-flex items-center justify-center w-8 h-8 rounded-lg border border-gray-300 bg-white text-gray-600 hover:bg-gray-50 hover:text-gray-900 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700 transition-colors", title: "Excel actions", "aria-haspopup": "menu", "aria-expanded": isOpen, children: _jsx(MoreVertical, { className: "w-4 h-4" }) }), isOpen && (_jsxs("div", { role: "menu", className: "absolute right-0 mt-1 w-44 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 z-50 py-1", children: [canImport && (_jsxs("button", { type: "button", role: "menuitem", onClick: () => {
                            setIsOpen(false);
                            onImport();
                        }, className: "flex items-center w-full px-4 py-2.5 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors", children: [_jsx(Upload, { className: "w-4 h-4 mr-3 text-gray-500 dark:text-gray-400" }), "Import Excel"] })), canExport && (_jsxs("button", { type: "button", role: "menuitem", onClick: () => {
                            setIsOpen(false);
                            onExport();
                        }, className: "flex items-center w-full px-4 py-2.5 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors", children: [_jsx(Download, { className: "w-4 h-4 mr-3 text-gray-500 dark:text-gray-400" }), "Export Excel"] }))] }))] }));
}
